"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMap = void 0;

var React = __importStar(require("react"));

function useMap(initialMap) {
  if (initialMap === void 0) {
    initialMap = {};
  }

  var _a = React.useState(initialMap),
      state = _a[0],
      setState = _a[1];

  var stableMethods = React.useMemo(function () {
    return {
      set: function set(key, value) {
        setState(function (prevState) {
          var _a;

          return __assign(__assign({}, prevState), (_a = {}, _a[key] = value, _a));
        });
      },
      setAll: function setAll(newMap) {
        setState(newMap);
      },
      remove: function remove(key) {
        setState(function (prevState) {
          var _a = prevState,
              _b = key,
              omit = _a[_b],
              rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);

          return rest;
        });
      },
      reset: function reset() {
        setState(initialMap);
      }
    };
  }, [setState]);
  var unstableMethods = {
    get: React.useCallback(function (key) {
      return state[key];
    }, [state])
  };

  var methods = __assign(__assign({}, stableMethods), unstableMethods);

  return [state, methods];
}

exports.useMap = useMap;